import { type FunctionalComponent, h } from '@stencil/core';

export interface IConversationalSearchProcessing {}

export const ConversationalSearchProcessing: FunctionalComponent<
  IConversationalSearchProcessing
> = () => {
    return (
      <uiaas-search-conversational-search-messages-wrapper>
        <section class="conversational-search-processing">
          <div class="ball1" />
          <div class="ball2" />
          <div class="ball3" />
        </section>
      </uiaas-search-conversational-search-messages-wrapper>
    );
};
